<script setup lang="ts">
import type { PageCardProps } from '#ui/types';
import lodashOmit from 'lodash-es/omit';

export interface StoryblokUiPageCardProps {
    blok: StoryblokUiPageCard;
}

// PROPS
const { blok } = defineProps<StoryblokUiPageCardProps>();

// DATA
const to = computed(() => (blok.to ? storyblokResolveLink(blok.to) : undefined));
const pageCardProps = computed<PageCardProps>(() =>
    lodashOmit(storyblokOmitEmptyValues<StoryblokUiPageCard>(blok), ['_uid', 'component', 'to', 'description', 'size'])
);
const ui = computed(() => {
    switch (blok.size) {
        case 'md':
            return {
                body: 'space-y-4',
                title: 'text-xl',
            };
        case 'lg':
            return {
                body: 'space-y-8',
                title: 'text-3xl',
            };

        default:
            return {};
    }
});
</script>

<template>
    <UPageCard v-editable="blok" v-bind="pageCardProps" :to="to" :ui="ui">
        <template v-if="blok.header?.length" #header>
            <StoryblokComponent v-for="h in blok.header" :key="h._uid" :blok="h" />
        </template>
        <template v-if="!!blok.description" #description>
            <StoryblokRichTextOverride :doc="blok.description" class="max-w-none" />
        </template>
        <template v-if="blok.body?.length" #default>
            <StoryblokComponent v-for="b in blok.body" :key="b._uid" :blok="b" />
        </template>
    </UPageCard>
</template>
